<template>
  <v-container class="px-3 px-sm-6 mt-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-row class="align-end" no-gutters>
          <v-col cols="12" sm="8" lg="10">
            <h1 class="text-h4 font-weight-bold">Rewards</h1>
            <h2 class="text-subtitle-1 ">
              Use your Reward Points to redeem exceptional products
            </h2>
            <v-chip v-if="me && me.id" class="text-subtitle-2 mb-0 mt-3">You have <strong class="mx-1">{{ me.rewardPoints ? me.rewardPoints.toLocaleString() : 0 }}</strong> Reward Points</v-chip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <template v-if="loading">
        <div  class="text-center w-100-percentage mt-6">
          <v-icon class="fa-spin">fal fa-spinner</v-icon>
        </div>
      </template>
      <template v-if="mounted && !loading">
        <v-col cols="12">
          <h3 class="text-overline font-weight-bold">Virtual rewards</h3>
          <v-divider />
        </v-col>
        <template v-for="(item, index) in items">
          <v-col v-if="item.data.type.uid === types.reward.type.virtual" :key="index" cols="12" md="6" lg="4" xl="3">
            <Card :item="item" :redeem-item="redeemItem" :stock="stock" />
          </v-col>
        </template>
        <v-col cols="12" class="mt-6">
          <h3 class="text-overline font-weight-bold">Physical rewards</h3>
          <v-divider />
        </v-col>
        <template v-for="(item, index) in items">
          <v-col v-if="item.data.type.uid === types.reward.type.physical" :key="index" cols="12" md="6" lg="4" xl="3">
            <Card :item="item" :redeem-item="redeemItem" :stock="stock" />
          </v-col>
        </template>
        <v-col cols="12">
          <div class="text-2  font-weight-bold mt-6 text-center">
            More rewards will be added soon...
          </div>
        </v-col>
        <!-- <v-col cols="12" class="mt-6">
          <h3 class="text-overline font-weight-bold">Passive initiative</h3>
          <v-divider />
        </v-col>
        <template v-for="(item, index) in items">
          <v-col v-if="item.data.type.uid === types.reward.type.passive" :key="index" cols="12" md="6" lg="4" xl="3">
            <Card :item="item" :redeem-item="redeemItem" :stock="stock" />
          </v-col>
        </template> -->
      </template>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import Card from '@/components/rewards/Card.vue'
import { displayConfirm } from '@/utils/swal'
import { EventBus } from '@/plugins/event-bus'
import types from '@/utils/types'

export default {
  components: {
    Card
  },
  data() {
    return {
      types,
      mounted: false,
      loading: false,
      busy: false,
      busyEnum: '',
      stock: undefined
    }
  },
  computed: {
    ...mapState({
      me: state => state.auth.user,
      items: state => state.rewards.items
    }),
    loggedIn() {
      return this.me && this.me.id
    }
  },
  async mounted() {
    this.mounted = true
    try {
      this.loading = true
      const stock = await this.$axios.$get('/rewards/product-stock')
      this.stock = stock.reduce((a, b) => {
        return { ...a, [b.sku]: b }
      }, {})
      if (this.items.length === 0) {
        await this.$store.dispatch('rewards/getItems')
      }
    } catch (error) {
      this.$asa.appInsights('Pages: rewards.vue - method: mounted', error)
    } finally {
      this.loading = false
    }
  },
  methods: {
    redeemItem(itemEnum, price) {
      if (this.loggedIn) {
        if (this.me.rewardPoints >= price) {
          displayConfirm(
            `Are you sure you wish to redeem this item for ${price} Reward Points, this action cannot be undone.`,
            async result => {
              if (result.isConfirmed) {
                try {
                  this.busy = true
                  this.busyEnum = itemEnum
                  const message = await this.$axios.$post('/rewards/redeem', {
                    type: itemEnum
                  })
                  await this.$auth.fetchUser()
                  EventBus.$emit('snackbar', {
                    text: message,
                    color: 'success'
                  })
                } catch (error) {
                  this.$asa.appInsights('Pages: rewards.vue - method: redeemItem', error)
                } finally {
                  this.busy = false
                  this.busyEnum = ''
                }
              }
            }
          )
        } else {
          EventBus.$emit('snackbar', {
            text: "You don't have enough Reward Points to redeem this item",
            color: 'info'
          })
        }
      } else {
        EventBus.$emit('snackbar', {
          text: 'Your need to be logged in to redeem rewards',
          color: 'info'
        })
      }
    }
  }
}
</script>
